<template>
  <div class="caseDetail noSel">
	  
	    <div class="head">
			<div class="tit">
				<i  @click="goLinks('/case')">case列表</i> ><span>初识亚马逊卖家后台</span>
			</div>
		</div>
		<div class="content">
			<div class="banner">
				<div class="left">
					<img src="http://image.510jl.com/image/7b2f2e80-ab58-4353-bc45-7937fb3b0d73.gif" alt="">
				</div>
				<div class="right">
					<div class="btnWrap">
						<div class="btn"  @click="isLond=true" >下载客户端</div>
					</div>
					<div class="name">
						初识亚马逊卖家后台 <span class="avts">免费</span>
					</div>
					<div class="dev">您将学会：认识亚马逊卖家后台基础模块</div>
					<div class="sm">说明：本案例主要学习在亚马逊卖家后台创建上传listing，listing（商品详情页面） 是您商品最直观的展现方式，也是买家全面了解您商品最有效的途径。</div>
					<div class="product">
						<div class="title">我们为您准备：</div>
						<div class="ul">
							<div class="li">
								<div class="img">
									<img src="../../../assets/images/pageIc.png" alt="">
								</div>
								<div class="na">模拟页面</div>
								<div class="dl">100%仿真页面，让您零 距离实操真实卖家后台</div>
							</div>
							<div class="li">
								<div class="img">
									<img src="../../../assets/images/ycic.png" alt="">
								</div>
								<div class="na">教学视频</div>
								<div class="dl">亚马逊资深大咖线上教学 模拟练习一点通</div>
							</div>
							<!-- <div class="li">
								<div class="img">
									<img src="../../../assets/images/fwIc.png" alt="">
								</div>
								<div class="na">案例素材</div>
								<div class="dl">提供全套模拟 练习素材，即拿即用</div>
							</div>
							<div class="li">
								<div class="img">
									<img src="../../../assets/images/bookIc.png" alt="">
								</div>
								<div class="na">知识点讲解</div>
								<div class="dl">知识点普及、各种干货 随心看，哪里不会点哪里</div>
							</div>
							<div class="li">
								<div class="img">
									<img src="../../../assets/images/khIc.png" alt="">
								</div>
								<div class="na">考核评分</div>
								<div class="dl">智能打分，实操考评 练习次数不上限</div>
							</div> -->
						</div>
					</div>
				</div>
			</div>
			<div class="boxWraps">
				<div class=WordSection1 style='layout-grid:15.6pt'>
					<p class=MsoNormal><span lang=EN-US><img width=555 height=313
					src="../../../assets/images/case/image001.jpg"></span></p>
					<p class=MsoNormal><span style='font-size:16.0pt;font-family:宋体'>欢迎来到零距离模拟平台</span></p>
					<p class=MsoNormal><span style='font-size:16.0pt;font-family:宋体'>这次的案例主要学习的是亚马逊卖家后台的功能模块的基础认识，分为十大导航与设置信息。亚马逊卖家后台在不断的更新，我们也已经模拟最新的基础页面供大家学习，您也可以同时打开教学视频及模拟页面，动手实操有效提高学习记忆力。</span></p>

					<p class=MsoNormal style='margin-left:0cm;text-indent:0cm'><b><span lang=EN-US
					style='font-size:16.0pt'>一、</span></b><b><span style='font-size:16.0pt;
					font-family:宋体'>亚马逊卖家后台的页面布局（分四大模块）。</span></b></p>

					<p class=MsoNormal><span lang=EN-US><img width=555 height=284
					src="../../../assets/images/case/image002.jpg"></span></p>

					<p class=MsoNormal style='margin-left:21.0pt;text-indent:-21.0pt'><span
					lang=EN-US style='font-size:8.0pt;font-family:Wingdings'>l<span
					style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp; </span></span><b><span
					style='font-size:14.0pt;font-family:宋体'>导航栏</span></b><span style='font-size:
					14.0pt;font-family:宋体'>（左上角的导航栏，也就是我们今天要着重讲解的十大导航，这里几乎包括了我们在运营亚马逊店铺过程中所有操作，例如我们要上传商品，看库存，看销量数据，以及看店铺的各项指标，店铺是否违规等一些信息都可以在导航里找到）</span></p>

					<p class=MsoNormal style='margin-left:21.0pt;text-indent:-21.0pt'><span
					lang=EN-US style='font-size:8.0pt;font-family:Wingdings'>l<span
					style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp; </span></span><b><span
					style='font-size:14.0pt;font-family:宋体'>搜索与设置区</span></b><span
					style='font-size:14.0pt;font-family:宋体'>（搜索框这里你可以直接搜索问题，或者你可能忘了一些信息在哪设置，都可以通过这里搜索关键字找到入口，设置：我们需要设置的店铺信息，例如我们店铺名称、存款方式修改，亚马逊物流的一些可选服务打开，都可以通过这里去修改）</span></p>

					<p class=MsoNormal style='margin-left:21.0pt;text-indent:-21.0pt'><span
					lang=EN-US style='font-size:8.0pt;font-family:Wingdings'>l<span
					style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp; </span></span><b><span
					style='font-size:14.0pt;font-family:宋体'>数据概况</span></b><span style='font-size:
					14.0pt;font-family:宋体'>（在这里我们可以看到我们今天的销售额有多少，有没有收到买家消息，</span><span lang=EN-US
					style='font-size:14.0pt'>IPI</span><span style='font-size:14.0pt;font-family:
					宋体'>分数等等。）</span></p>

					<p class=MsoNormal style='margin-left:21.0pt;text-indent:-21.0pt'><span
					lang=EN-US style='font-size:8.0pt;font-family:Wingdings'>l<span
					style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp; </span></span><b><span
					style='font-size:14.0pt;font-family:宋体'>政策资讯及卖家大学</span></b><span
					style='font-size:14.0pt;font-family:宋体'>（亚马逊的政策资讯，还有卖家论坛，卖家大学等，我们可以通过这里看到亚马逊最新的消息以及学习更多的运营知识。）</span></p>

					<p class=MsoNormal><span lang=EN-US style='font-size:14.0pt'>&nbsp;</span></p>

					<p class=MsoNormal style='margin-left:0cm;text-indent:0cm'><span lang=EN-US
					style='font-size:18.0pt'>二、</span><b><span style='font-size:16.0pt;font-family:
					宋体'>目录</span></b></p>

					<p class=MsoNormal><span lang=EN-US><img width=555 height=281 id="图片 1"
					src="../../../assets/images/case/image003.jpg"></span></p>

					<p class=MsoNormal><span lang=EN-US style='font-size:18.0pt'>&nbsp;</span></p>

					<p class=MsoNormal style='margin-left:21.0pt;text-indent:-21.0pt'><span
					lang=EN-US style='font-size:8.0pt;font-family:Wingdings'>l<span
					style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp; </span></span><b><span
					style='font-size:14.0pt;font-family:宋体'>添加商品：</span></b><span style='font-size:
					14.0pt;font-family:宋体'>从这里进入可以添加你的新商品（分单一上传及批量上传），也可以进行跟卖。</span></p>

					<p class=MsoNormal style='margin-left:21.0pt;text-indent:-21.0pt'><span
					lang=EN-US style='font-size:8.0pt;font-family:Wingdings'>l<span
					style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp; </span></span><b><span
					style='font-size:14.0pt;font-family:宋体'>补全你的草稿：</span></b><span
					style='font-size:14.0pt;font-family:宋体'>上传商品时保存的草稿都在这里，你可以在这里继续编辑你的</span><span
					lang=EN-US style='font-size:14.0pt'>listing</span><span style='font-size:14.0pt;
					font-family:宋体'>。</span></p>

					<p class=MsoNormal style='margin-left:21.0pt;text-indent:-21.0pt'><span
					lang=EN-US style='font-size:8.0pt;font-family:Wingdings'>l<span
					style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp; </span></span><b><span
					style='font-size:14.0pt;font-family:宋体'>查看销售申请：</span></b><span
					style='font-size:14.0pt;font-family:宋体'>如果你的商品需要进行一个分类审核，那就可以在这里查看审核状态是否已经通过。</span></p>

					<p class=MsoNormal><span lang=EN-US style='font-size:14.0pt'>&nbsp;</span></p>

					<p class=MsoNormal style='margin-left:0cm;text-indent:0cm'><span lang=EN-US
					style='font-size:14.0pt'>三、</span><b><span style='font-size:16.0pt;font-family:
					宋体'>库存</span></b></p>

					<p class=MsoNormal><span lang=EN-US><img width=555 height=237
					src="../../../assets/images/case/image004.jpg"></span></p>

					<p class=MsoNormal style='margin-left:21.0pt;text-indent:-21.0pt'><span
					lang=EN-US style='font-size:8.0pt;font-family:Wingdings'>l<span
					style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp; </span></span><b><span
					style='font-size:14.0pt;font-family:宋体'>管理库存：</span></b><span style='font-size:
					14.0pt;font-family:宋体'>上传的所有产品库存情况，包括了自发货还有</span><span lang=EN-US
					style='font-size:14.0pt'>FBA</span><span style='font-size:14.0pt;font-family:
					宋体'>的一个库存。</span></p>

					<p class=MsoNormal style='margin-left:21.0pt;text-indent:-21.0pt'><span
					lang=EN-US style='font-size:8.0pt;font-family:Wingdings'>l<span
					style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp; </span></span><b><span
					style='font-size:14.0pt;font-family:宋体'>管理亚马逊库存：</span></b><span
					style='font-size:14.0pt;font-family:宋体'>只会看到你转换成亚马逊配送的产品库存情况。</span></p>

					<p class=MsoNormal style='margin-left:21.0pt;text-indent:-21.0pt'><span
					lang=EN-US style='font-size:8.0pt;font-family:Wingdings'>l<span
					style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp; </span></span><b><span
					style='font-size:14.0pt;font-family:宋体'>改善商品信息质量</span></b><span
					style='font-size:14.0pt;font-family:宋体'>：亚马逊检测到你的商品上传后，有哪些信息需要补充才能更具有曝光率的，亚马逊就会把需要补充商品的链接放这里，你可以根据建议去补充完整你的商品信息。</span></p>

					<p class=MsoNormal style='margin-left:21.0pt;text-indent:-21.0pt'><span
					lang=EN-US style='font-size:8.0pt;font-family:Wingdings'>l<span
					style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp; </span></span><b><span
					style='font-size:14.0pt;font-family:宋体'>库存规划：</span></b><span style='font-size:
					14.0pt;font-family:宋体'>库存数据，例如有没有需要补货，还有就是挤压的库存。</span></p>

					<p class=MsoNormal style='margin-left:21.0pt;text-indent:-21.0pt'><span
					lang=EN-US style='font-size:8.0pt;font-family:Wingdings'>l<span
					style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp; </span></span><b><span
					style='font-size:14.0pt;font-family:宋体'>亚马逊物流远程配送：</span></b><span
					style='font-size:14.0pt;font-family:宋体'>如果你想要使用美国亚马逊物流的库存向加拿大或者墨西哥境内买家销售商品，就可以通过这里开启，开启后会收取相关费用。</span></p>

					<p class=MsoNormal style='margin-left:21.0pt;text-indent:-21.0pt'><span
					lang=EN-US style='font-size:8.0pt;font-family:Wingdings'>l<span
					style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp; </span></span><b><span
					style='font-size:14.0pt;font-family:宋体'>添加商品以及批量添加商品：</span></b><span
					style='font-size:14.0pt;font-family:宋体'>这里在目录导航也有说到，是一个重叠的功能，大概也可以知道这两个功能作为卖家来说使用率是比较高的了。</span></p>

					<p class=MsoNormal style='margin-left:21.0pt;text-indent:-21.0pt'><span
					lang=EN-US style='font-size:8.0pt;font-family:Wingdings'>l<span
					style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp; </span></span><b><span
					style='font-size:14.0pt;font-family:宋体'>库存报告：</span></b><span style='font-size:
					14.0pt;font-family:宋体'>可以下载所有商品的库存数据到本地。</span></p>

					<p class=MsoNormal style='margin-left:21.0pt;text-indent:-21.0pt'><span
					lang=EN-US style='font-size:8.0pt;font-family:Wingdings'>l<span
					style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp; </span></span><b><span
					style='font-size:14.0pt;font-family:宋体'>全球销售：</span></b><span style='font-size:
					14.0pt;font-family:宋体'>开通全球销售服务，例如你在美国商城的商品可以直接同步到加拿大商城，并且可以看到你在每个商城的一个销售数据。</span></p>

					<p class=MsoNormal style='margin-left:21.0pt;text-indent:-21.0pt'><span
					lang=EN-US style='font-size:8.0pt;font-family:Wingdings'>l<span
					style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp; </span></span><b><span
					style='font-size:14.0pt;font-family:宋体'>管理亚马逊货件：</span></b><span lang=EN-US
					style='font-size:14.0pt'>FBA</span><span style='font-size:14.0pt;font-family:
					宋体'>补货，缺货，移除都在这里操作</span></p>

					<p class=MsoNormal style='margin-left:21.0pt;text-indent:-21.0pt'><span
					lang=EN-US style='font-size:8.0pt;font-family:Wingdings'>l<span
					style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp; </span></span><b><span
					style='font-size:14.0pt;font-family:宋体'>上传图片以及上传管理视频：</span></b><span
					style='font-size:14.0pt;font-family:宋体'>这是最近亚马逊新增的两个工具，你可以通过这里去批量上传你的商品图片以及视频，并且可以看到所有图片的上传状态。相对之前的只能上传一件商品的图片，也只能查看一件商品的图片上传状态，现在的这两个工具更便利。</span></p>

					<p class=MsoNormal><span lang=EN-US style='font-size:14.0pt'>&nbsp;</span></p>

					<p class=MsoNormal style='margin-left:0cm;text-indent:0cm'><span lang=EN-US
					style='font-size:14.0pt'>四、</span><b><span style='font-size:16.0pt;font-family:
					宋体'>确定价格</span></b></p>

					<p class=MsoNormal><span lang=EN-US style='font-size:14.0pt'><img width=556
					height=172 id="图片 10" src="../../../assets/images/case/image005.jpg"></span></p>

					<p class=MsoNormal style='margin-left:21.0pt;text-indent:-21.0pt'><span
					lang=EN-US style='font-size:8.0pt;font-family:Wingdings'>l<span
					style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp; </span></span><b><span
					style='font-size:14.0pt;font-family:宋体'>定价状况：</span></b><span style='font-size:
					14.0pt;font-family:宋体'>亚马逊会结合市场同类型的商品价格给你提供一个参考值，你可以直接从这里参考定价你的商品，当然了，也可以通过你的商品实际成本跟物流成本去衡量定价。</span></p>

					<p class=MsoNormal style='margin-left:21.0pt;text-indent:-21.0pt'><span
					lang=EN-US style='font-size:8.0pt;font-family:Wingdings'>l<span
					style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp; </span></span><b><span
					style='font-size:14.0pt;font-family:宋体'>管理定价：</span></b><span style='font-size:
					14.0pt;font-family:宋体'>这个可以看到所有在售商品的编辑页面，方便调整价格。</span></p>

					<p class=MsoNormal style='margin-left:21.0pt;text-indent:-21.0pt'><span
					lang=EN-US style='font-size:8.0pt;font-family:Wingdings'>l<span
					style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp; </span></span><b><span
					style='font-size:14.0pt;font-family:宋体'>修复价格警告：</span></b><span
					style='font-size:14.0pt;font-family:宋体'>如果亚马逊检测到你的商品价格过高或过低，跟市场定价出入太多，就会给你发送价格警告提醒，你需要重新设定价格，不然会判断你扰乱市场秩序。</span></p>

					<p class=MsoNormal style='margin-left:21.0pt;text-indent:-21.0pt'><span
					lang=EN-US style='font-size:8.0pt;font-family:Wingdings'>l<span
					style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp; </span></span><b><span
					style='font-size:14.0pt;font-family:宋体'>自动定价：</span></b><span style='font-size:
					14.0pt;font-family:宋体'>在这里你可以设定你商品的价格区间，亚马逊会根据市场情况在区间范围自动调整。</span></p>

					<p class=MsoNormal style='margin-left:21.0pt;text-indent:-21.0pt'><span
					lang=EN-US style='font-size:8.0pt;font-family:Wingdings'>l<span
					style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp; </span></span><b><span
					style='font-size:14.0pt;font-family:宋体'>佣金折扣：</span></b><span style='font-size:
					14.0pt;font-family:宋体'>亚马逊会对一些折扣率比较大的商品提供佣金比例服务</span></p>

					<p class=MsoNormal><span lang=EN-US style='font-size:14.0pt'>&nbsp;</span></p>

					<p class=MsoNormal style='margin-left:0cm;text-indent:0cm'><span lang=EN-US
					style='font-size:14.0pt'>五、</span><b><span style='font-size:16.0pt;font-family:
					宋体'>订单</span></b></p>

					<p class=MsoNormal><span lang=EN-US style='font-size:14.0pt'><img width=555
					height=218 id="图片 11" src="../../../assets/images/case/image006.jpg"></span></p>

					<p class=MsoNormal style='margin-left:21.0pt;text-indent:-21.0pt'><span
					lang=EN-US style='font-size:8.0pt;font-family:Wingdings'>l<span
					style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp; </span></span><b><span
					style='font-size:14.0pt;font-family:宋体'>管理订单：</span></b><span style='font-size:
					14.0pt;font-family:宋体'>这里可以查看所有已经购买的订单和配送中的订单，还可以设置查询条件，订单编号查找，迅速找到对应的买家订单。</span></p>

					<p class=MsoNormal style='margin-left:21.0pt;text-indent:-21.0pt'><span
					lang=EN-US style='font-size:8.0pt;font-family:Wingdings'>l<span
					style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp; </span></span><b><span
					style='font-size:14.0pt;font-family:宋体'>订单报告：</span></b><span style='font-size:
					14.0pt;font-family:宋体'>可以下载过去</span><span lang=EN-US style='font-size:14.0pt'>90</span><span
					style='font-size:14.0pt;font-family:宋体'>天内的所有卖家自行配送的订单表格，其中包括等待中的订单和待处理的订单。</span></p>

					<p style='margin-top:6.6pt;margin-right:0cm;margin-bottom:18.9pt;margin-left:
					21.0pt;text-align:justify;text-justify:inter-ideograph;text-indent:-21.0pt;
					background:white'><span lang=EN-US style='font-size:8.0pt;font-family:Wingdings'>l<span
					style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp; </span></span><b><span
					style='font-size:14.0pt;font-family:宋体;color:black'>上传订单相关文件：</span></b><span
					style='font-size:14.0pt;font-family:宋体;color:black'>下载亚马逊提供的表格模板，可以进行批量修改订单，例如盘点，订单取消，配送等等</span></p>

					<p style='margin-top:6.6pt;margin-right:0cm;margin-bottom:18.9pt;margin-left:
					21.0pt;text-align:justify;text-justify:inter-ideograph;text-indent:-21.0pt;
					background:white'><span lang=EN-US style='font-size:8.0pt;font-family:Wingdings'>l<span
					style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp; </span></span><b><span
					style='font-size:14.0pt;font-family:宋体;color:black'>管理退货：</span></b><span
					style='font-size:14.0pt;font-family:宋体;color:black'>这里可以下载过去买家退货订单；以及可以设置不同的搜索条件来快速的找到需要的买家订单。</span></p>

					<p style='margin-top:6.6pt;margin-right:0cm;margin-bottom:18.9pt;margin-left:
					21.0pt;text-align:justify;text-justify:inter-ideograph;text-indent:-21.0pt;
					background:white'><span lang=EN-US style='font-size:8.0pt;font-family:Wingdings'>l<span
					style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp; </span></span><b><span
					style='font-size:14.0pt;font-family:宋体;color:black'>管理</span></b><b><span
					lang=EN-US style='font-size:14.0pt;color:black'>SAFE-T</span></b><b><span
					style='font-size:14.0pt;font-family:宋体;color:black'>索赔：</span></b><span
					style='font-size:14.0pt;font-family:宋体;color:black'>这也是最近新增的一个功能，卖家可以针对买家的退款请求提出异议并要求索赔，以获得相应赔偿。只要亚马逊确定卖家不是过错方，那么卖家即可获得相应赔偿。例如亚马逊确定买家存在滥用亚马逊退货或退款政策的行为，再或者退货邮寄标签已由亚马逊发放，但商品在退货过程中丢失，这种情况都有可能得到相应的赔偿，我们就可以在这里提出申请。</span></p>

					<p class=MsoNormal style='margin-left:0cm;text-indent:0cm'><span lang=EN-US
					style='font-size:14.0pt'>六、</span><b><span style='font-size:16.0pt;font-family:
					宋体'>广告</span></b></p>

					<p style='margin-top:6.6pt;margin-right:0cm;margin-bottom:18.9pt;margin-left:
					21.0pt;text-align:justify;text-justify:inter-ideograph;text-indent:-21.0pt;
					background:white'><span lang=EN-US style='font-size:8.0pt;font-family:Wingdings'>l<span
					style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp; </span></span><span
					lang=EN-US style='font-size:14.0pt;color:black'><img width=555 height=241
					id="图片 12" src="../../../assets/images/case/image007.jpg"></span><b><span style='font-size:
					14.0pt;font-family:宋体;color:black'>广告活动管理：</span></b><span style='font-size:
					14.0pt;font-family:宋体;color:black'>包含广告计划的创建，有自动或者手动的、广告数据报表的查看和下载、运行中的广告优化等相关事项</span></p>

					<p style='margin-top:6.6pt;margin-right:0cm;margin-bottom:18.9pt;margin-left:
					21.0pt;text-align:justify;text-justify:inter-ideograph;text-indent:-21.0pt;
					background:white'><span lang=EN-US style='font-size:8.0pt;font-family:Wingdings'>l<span
					style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp; </span></span><b><span
					lang=EN-US style='font-size:14.0pt;color:black'>A+</span></b><b><span
					style='font-size:14.0pt;font-family:宋体;color:black'>页面：</span></b><span
					style='font-size:14.0pt;font-family:宋体;color:black'>什么是</span><span lang=EN-US
					style='font-size:14.0pt;color:black'>A+</span><span style='font-size:14.0pt;
					font-family:宋体;color:black'>页面呢，通常我们创建商品的时候商品描述的填写只能填入文字，浏览起来会比较枯燥，</span><span
					lang=EN-US style='font-size:14.0pt;color:black'>A+</span><span
					style='font-size:14.0pt;font-family:宋体;color:black'>这里就可以让你把图片跟文字结合在一起展示在商品描述里，通过精美的排版得到更有效的转化你的商品销售量，但要注意的是，这里只有申请了品牌注册的卖家才可以操作。</span></p>

					<p style='margin-top:6.6pt;margin-right:0cm;margin-bottom:18.9pt;margin-left:
					21.0pt;text-align:justify;text-justify:inter-ideograph;text-indent:-21.0pt;
					background:white'><span lang=EN-US style='font-size:8.0pt;font-family:Wingdings'>l<span
					style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp; </span></span><b><span
					style='font-size:14.0pt;font-family:宋体;color:black'>早期评论者计划跟</span></b><b><span
					lang=EN-US style='font-size:14.0pt;color:black'>Vine</span></b><b><span
					style='font-size:14.0pt;font-family:宋体;color:black'>：</span></b><span
					style='font-size:14.0pt;font-family:宋体;color:black'>我们商品的早期想要快速得到一些买家的评价，就可以通过这个开启这项服务得到效果，开启后亚马逊会通过已注册的商品的买家提供能一些小奖励或者是免费送产品的形式，来换取他们对商品提供反馈。这里也是需要注册品牌的卖家才可以开启的。</span></p>

					<p style='margin-top:6.6pt;margin-right:0cm;margin-bottom:18.9pt;margin-left:
					21.0pt;text-align:justify;text-justify:inter-ideograph;text-indent:-21.0pt;
					background:white'><span lang=EN-US style='font-size:8.0pt;font-family:Wingdings'>l<span
					style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp; </span></span><b><span
					style='font-size:14.0pt;font-family:宋体;color:black'>秒杀：</span></b><span
					style='font-size:14.0pt;font-family:宋体;color:black'>卖家在做站内活动推广的时候，比较常用的一个功能，包括日常秒杀，</span><span
					lang=EN-US style='font-size:14.0pt;color:black'>7</span><span style='font-size:
					14.0pt;font-family:宋体;color:black'>天秒杀，都可以在这里参加，但是这里会对你的商品有一些门槛要求。</span></p>

					<p style='margin-top:6.6pt;margin-right:0cm;margin-bottom:18.9pt;margin-left:
					21.0pt;text-align:justify;text-justify:inter-ideograph;text-indent:-21.0pt;
					background:white'><span lang=EN-US style='font-size:8.0pt;font-family:Wingdings'>l<span
					style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp; </span></span><b><span
					style='font-size:14.0pt;font-family:宋体;color:black'>优惠券：</span></b><span
					style='font-size:14.0pt;font-family:宋体;color:black'>我们可以在这里为商品创建一些优惠券给到买家使用</span></p>

					<p style='margin-top:6.6pt;margin-right:0cm;margin-bottom:18.9pt;margin-left:
					21.0pt;text-align:justify;text-justify:inter-ideograph;text-indent:-21.0pt;
					background:white'><span lang=EN-US style='font-size:8.0pt;font-family:Wingdings'>l<span
					style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp; </span></span><b><span
					lang=EN-US style='font-size:14.0pt;color:black'>Prime </span></b><b><span
					style='font-size:14.0pt;font-family:宋体;color:black'>专享折扣：</span></b><span
					style='font-size:14.0pt;font-family:宋体;color:black'>这个是面对</span><span
					lang=EN-US style='font-size:14.0pt;color:black'>Prime</span><span
					style='font-size:14.0pt;font-family:宋体;color:black'>会员的价格折扣，类似于国内的某宝的</span><span
					lang=EN-US style='font-size:14.0pt;color:black'>88</span><span
					style='font-size:14.0pt;font-family:宋体;color:black'>会员，但是前提条件是这个商品为亚马逊配送，商品需要有</span><span
					lang=EN-US style='font-size:14.0pt;color:black'>3</span><span style='font-size:
					14.0pt;font-family:宋体;color:black'>星以上的评级或者没有评级，再者就是折扣必须至少比非会员非促销的价格优惠</span><span
					lang=EN-US style='font-size:14.0pt;color:black'>10%</span><span
					style='font-size:14.0pt;font-family:宋体;color:black'>。</span></p>

					<p style='margin-top:6.6pt;margin-right:0cm;margin-bottom:18.9pt;margin-left:
					21.0pt;text-align:justify;text-justify:inter-ideograph;text-indent:-21.0pt;
					background:white'><span lang=EN-US style='font-size:8.0pt;font-family:Wingdings'>l<span
					style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp; </span></span><b><span
					style='font-size:14.0pt;font-family:宋体;color:black'>管理促销：</span></b><span
					style='font-size:14.0pt;font-family:宋体;color:black'>这里可以设置店铺的营销活动，满赠满减活动等等</span></p>

					<p class=MsoNormal style='margin-left:0cm;text-indent:0cm'><span lang=EN-US
					style='font-size:14.0pt'>七、</span><b><span style='font-size:16.0pt;font-family:
					宋体'>品牌旗舰店</span></b></p>

					<p style='margin-top:6.6pt;margin-right:0cm;margin-bottom:18.9pt;margin-left:
					0cm;text-align:justify;text-justify:inter-ideograph;background:white'><span
					lang=EN-US style='font-size:14.0pt;color:black'><img width=555 height=205
					id="图片 4" src="../../../assets/images/case/image008.jpg"></span></p>

					<p style='margin-top:6.6pt;margin-right:0cm;margin-bottom:18.9pt;margin-left:
					21.0pt;text-align:justify;text-justify:inter-ideograph;text-indent:-21.0pt;
					background:white'><span lang=EN-US style='font-size:8.0pt;font-family:Wingdings'>l<span
					style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp; </span></span><b><span
					style='font-size:14.0pt;font-family:宋体;color:black'>管理店铺：</span></b><span
					style='font-size:14.0pt;font-family:宋体;color:black'>我们可以通过这里去进行我们的一个品牌备案，以及备案通过后可以装修我们的品牌店铺，通过统一的装修风格，也是有利于积累粉丝群体的。</span></p>

					<p class=MsoNormal style='margin-left:0cm;text-indent:0cm'><span lang=EN-US
					style='font-size:14.0pt'>八、</span><b><span style='font-size:16.0pt;font-family:
					宋体'>增长</span></b></p>

					<p style='margin-top:6.6pt;margin-right:0cm;margin-bottom:18.9pt;margin-left:
					0cm;text-align:justify;text-justify:inter-ideograph;background:white'><span
					lang=EN-US style='font-size:14.0pt;color:black'><img width=556 height=205
					id="图片 5" src="../../../assets/images/case/image009.jpg"></span></p>

					<p style='margin-top:6.6pt;margin-right:0cm;margin-bottom:18.9pt;margin-left:
					21.0pt;text-align:justify;text-justify:inter-ideograph;text-indent:-21.0pt;
					background:white'><span lang=EN-US style='font-size:8.0pt;font-family:Wingdings'>l<span
					style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp; </span></span><b><span
					style='font-size:14.0pt;font-family:宋体;color:black'>配送计划：</span></b><span
					style='font-size:14.0pt;font-family:宋体;color:black'>我们可以在这里参加轻小商品的计划和亚马逊全球物流服务，亚马逊物流轻小商品计划是针对由本国运输、轻小且价格较低的选品，专门推出的一种配送解决方案。通过让符合要求的</span><span
					lang=EN-US style='font-size:14.0pt;color:black'>ASIN</span><span
					style='font-size:14.0pt;font-family:宋体;color:black'>加入轻小计划，您可以享受相对标准</span><span
					lang=EN-US style='font-size:14.0pt;color:black'>FBA</span><span
					style='font-size:14.0pt;font-family:宋体;color:black'>更低的配送费用。如果你的商品条件刚好符合要求，就可以通过开启这项服务为你省下不少物流运输成本。</span></p>

					<p style='margin-top:6.6pt;margin-right:0cm;margin-bottom:18.9pt;margin-left:
					21.0pt;text-align:justify;text-justify:inter-ideograph;text-indent:-21.0pt;
					background:white'><span lang=EN-US style='font-size:8.0pt;font-family:Wingdings'>l<span
					style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp; </span></span><b><span
					style='font-size:14.0pt;font-family:宋体;color:black'>推荐计划：</span></b><span
					style='font-size:14.0pt;font-family:宋体;color:black'>这里是亚马逊向你推广的一些他们有的服务，就例如前面我们也介绍过的，建立我们的品牌，创建一些秒杀活动去增加流量，使用优惠券，使用亚马逊全球服务等等一整套计划，我们可以根据自身商品的情况去开通这些服务。</span></p>

					<p style='margin-top:6.6pt;margin-right:0cm;margin-bottom:18.9pt;margin-left:
					21.0pt;text-align:justify;text-justify:inter-ideograph;text-indent:-21.0pt;
					background:white'><span lang=EN-US style='font-size:8.0pt;font-family:Wingdings'>l<span
					style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp; </span></span><b><span
					style='font-size:14.0pt;font-family:宋体;color:black'>定制计划：</span></b><span
					style='font-size:14.0pt;font-family:宋体;color:black'>如果有买家按需定制你的商品，就可以在这里开启定制计划，也就是我们可以通过这个功能把商品批量给到买家，买家也可以借助这个功能，去对商品进行图片文本的编辑后进行商品的跟卖。</span></p>

					<p class=MsoNormal style='margin-left:0cm;text-indent:0cm'><span lang=EN-US
					style='font-size:14.0pt'>九、</span><b><span style='font-size:16.0pt;font-family:
					宋体'>数据报告</span></b></p>

					<p style='margin-top:6.6pt;margin-right:0cm;margin-bottom:18.9pt;margin-left:
					0cm;text-align:justify;text-justify:inter-ideograph;background:white'><span
					lang=EN-US style='font-size:14.0pt;color:black'><img width=555 height=206
					id="图片 6" src="../../../assets/images/case/image010.jpg"></span></p>

					<p style='margin-top:0cm;margin-right:0cm;margin-bottom:26.25pt;margin-left:
					21.0pt;text-indent:-21.0pt;line-height:21.0pt;background:white'><span
					lang=EN-US style='font-size:8.0pt;font-family:Wingdings'>l<span
					style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp; </span></span><b><span
					style='font-size:14.0pt;font-family:宋体;color:black'>付款：</span></b><span
					style='font-size:14.0pt;font-family:宋体;color:black'>在这里可以查看所有的订单付款数据跟明细，包括看每月收入统计，销售额，支出等，也可以使用筛选条件来筛选我们在哪一段时间范围的订单进行下载，下载后也方便整理销售报表。</span></p>

					<p class=MsoNormal style='margin-left:21.0pt;text-indent:-21.0pt'><span
					lang=EN-US style='font-size:8.0pt;font-family:Wingdings'>l<span
					style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp; </span></span><b><span
					style='font-size:14.0pt;font-family:宋体'>亚马逊销售指导：</span></b><span
					style='font-size:14.0pt;font-family:宋体'>亚马逊会针对你的商品以及店铺情况提出销售上的一些建议，我们可以进行参考</span></p>

					<p class=MsoNormal style='margin-left:21.0pt;text-indent:-21.0pt'><span
					lang=EN-US style='font-size:8.0pt;font-family:Wingdings'>l<span
					style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp; </span></span><b><span
					style='font-size:14.0pt;font-family:宋体'>业务报告：</span></b><span style='font-size:
					14.0pt;font-family:宋体'>在运营店铺过程会经常用的功能分析，这里可以看到商品的成交，流量，转化率，浏览量等数据，数据也是以图表的方式进行展开，更直观查看我们的一个商品趋势。</span></p>

					<p class=MsoNormal style='margin-left:21.0pt;text-indent:-21.0pt'><span
					lang=EN-US style='font-size:8.0pt;font-family:Wingdings'>l<span
					style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp; </span></span><b><span
					style='font-size:14.0pt;font-family:宋体'>库存和销售报告：</span></b><span
					style='font-size:14.0pt;font-family:宋体'>这里可以看到</span><span lang=EN-US
					style='font-size:14.0pt'>FBA</span><span style='font-size:14.0pt;font-family:
					宋体'>商品的配送报告，报告包含了很详细的内容，如库存剩余，销售量，付款，优惠，仓储费，赔偿费，移除订单。</span></p>

					<p class=MsoNormal style='margin-left:21.0pt;text-indent:-21.0pt'><span
					lang=EN-US style='font-size:8.0pt;font-family:Wingdings'>l<span
					style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp; </span></span><b><span
					style='font-size:14.0pt;font-family:宋体'>广告：</span></b><span style='font-size:
					14.0pt;font-family:宋体'>可以针对于你开的广告关键词数据和商品明细进行下载，便于广告的优化。</span></p>

					<p class=MsoNormal style='margin-left:21.0pt;text-indent:-21.0pt'><span
					lang=EN-US style='font-size:8.0pt;font-family:Wingdings'>l<span
					style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp; </span></span><b><span
					style='font-size:14.0pt;font-family:宋体'>退货报告</span></b><span style='font-size:
					14.0pt;font-family:宋体'>：可以查看买家退货报告，其中包括有退货的商品名称，数量，退货原因，买家的评论等等。</span></p>

					<p class=MsoNormal style='margin-left:21.0pt;text-indent:-21.0pt'><span
					lang=EN-US style='font-size:8.0pt;font-family:Wingdings'>l<span
					style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp; </span></span><b><span
					style='font-size:14.0pt;font-family:宋体'>自定义报告</span></b><span style='font-size:
					14.0pt;font-family:宋体'>：这里可以选择你想要的数据报告进行下载。</span></p>

					<p class=MsoNormal style='margin-left:21.0pt;text-indent:-21.0pt'><span
					lang=EN-US style='font-size:8.0pt;font-family:Wingdings'>l<span
					style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp; </span></span><b><span
					style='font-size:14.0pt;font-family:宋体'>税务文件库：</span></b><span
					style='font-size:14.0pt;font-family:宋体'>查看店铺的税务情况，想要了解税务信息可以到这里进行下载。</span></p>

					<p class=MsoNormal><span lang=EN-US style='font-size:14.0pt'>&nbsp;</span></p>

					<p class=MsoNormal style='margin-left:0cm;text-indent:0cm'><span lang=EN-US
					style='font-size:14.0pt'>十、</span><b><span style='font-size:16.0pt;font-family:
					宋体'>绩效</span></b></p>

					<p class=MsoNormal><span lang=EN-US style='font-size:14.0pt'><img width=555
					height=178 id="图片 7" src="../../../assets/images/case/image011.jpg"></span></p>

					<p class=MsoNormal><span lang=EN-US style='font-size:14.0pt'>&nbsp;</span></p>

					<p class=MsoNormal style='margin-left:21.0pt;text-indent:-21.0pt'><span
					lang=EN-US style='font-size:8.0pt;font-family:Wingdings'>l<span
					style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp; </span></span><b><span
					style='font-size:14.0pt;font-family:宋体'>账户状况：</span></b><span style='font-size:
					14.0pt;font-family:宋体'>可以看到我们的一个服务绩效，账户的状况评级，有没有负面反馈，买家投诉，政策违规等，并且如果出现了这些现象我们需要快速去解决问题，如果长时间不解决则会导致店铺的运营造成很大的影响。</span></p>

					<p class=MsoNormal style='margin-left:21.0pt;text-indent:-21.0pt'><span
					lang=EN-US style='font-size:8.0pt;font-family:Wingdings'>l<span
					style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp; </span></span><b><span
					style='font-size:14.0pt;font-family:宋体'>反馈：</span></b><span style='font-size:
					14.0pt;font-family:宋体'>买家对商品的一个评级与评论我们都可以从这里看到</span></p>

					<p class=MsoNormal style='margin-left:21.0pt;text-indent:-21.0pt'><span
					lang=EN-US style='font-size:8.0pt;font-family:Wingdings'>l<span
					style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp; </span></span><b><span
					style='font-size:14.0pt;font-family:宋体'>亚马逊商城交易保障索赔：</span></b><span
					style='font-size:14.0pt;font-family:宋体'>如果买家对商品的配送时效跟商品状况不满意，我们没有给予处理的话，通常买家就会开</span><span
					lang=EN-US style='font-size:14.0pt'>a-z</span><span style='font-size:14.0pt;
					font-family:宋体'>来投诉，由亚马逊介入判定是否投诉成功。如果我们是新账户，那么被买家开几个</span><span lang=EN-US
					style='font-size:14.0pt'>a-z</span><span style='font-size:14.0pt;font-family:
					宋体'>就会直接挂掉。但是我们可以用这个方法进行申述，提出异议索赔。前提需要我们有足够的理由可以提出申述。</span></p>

					<p class=MsoNormal style='margin-left:21.0pt;text-indent:-21.0pt'><span
					lang=EN-US style='font-size:8.0pt;font-family:Wingdings'>l<span
					style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp; </span></span><b><span
					style='font-size:14.0pt;font-family:宋体'>信用卡拒付索赔：</span></b><span
					style='font-size:14.0pt;font-family:宋体'>国外的信用卡付款后，在</span><span lang=EN-US
					style='font-size:14.0pt'>180</span><span style='font-size:14.0pt;font-family:
					宋体'>天内是可以向</span><span lang=EN-US style='font-size:14.0pt'>visa</span><span
					style='font-size:14.0pt;font-family:宋体'>组织申请退款的，这就叫做信用卡拒付，比如盗刷，客户就有可能拒付。</span></p>

					<p class=MsoNormal style='margin-left:21.0pt;text-indent:-21.0pt'><span
					lang=EN-US style='font-size:8.0pt;font-family:Wingdings'>l<span
					style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp; </span></span><b><span
					style='font-size:14.0pt;font-family:宋体'>业绩通知：</span></b><span style='font-size:
					14.0pt;font-family:宋体'>小红旗的信息，关系账户的各种安全，政策的信息。</span></p>

					<p class=MsoNormal style='margin-left:21.0pt;text-indent:-21.0pt'><span
					lang=EN-US style='font-size:8.0pt;font-family:Wingdings'>l<span
					style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp; </span></span><b><span
					style='font-size:14.0pt;font-family:宋体'>买家之声：</span></b><span style='font-size:
					14.0pt;font-family:宋体'>可以了解买家满意度的状况，查看买家对商品或商品信息的反馈，并采取措施解决商品和商品信息问题。</span></p>

					<p class=MsoNormal style='margin-left:21.0pt;text-indent:-21.0pt'><span
					lang=EN-US style='font-size:8.0pt;font-family:Wingdings'>l<span
					style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp; </span></span><b><span
					style='font-size:14.0pt;font-family:宋体'>卖家大学：</span></b><span style='font-size:
					14.0pt;font-family:宋体'>各种店铺基础操作的教学视频，操作规则，还有政策讲解，可以通过这里去学习。</span></p>

					<p class=MsoNormal><span lang=EN-US style='font-size:14.0pt'>&nbsp;</span></p>

					<p class=MsoNormal><span lang=EN-US style='font-size:14.0pt'>&nbsp;</span></p>

					<p class=MsoNormal><span lang=EN-US style='font-size:14.0pt'>&nbsp;</span></p>

					<p class=MsoNormal><span lang=EN-US style='font-size:14.0pt'>&nbsp;</span></p>

					<p class=MsoNormal style='margin-left:0cm;text-indent:0cm'><span lang=EN-US
					style='font-size:14.0pt'>十一、</span><b><span style='font-size:16.0pt;font-family:
					宋体'>应用商店</span></b></p>

					<p class=MsoNormal><span lang=EN-US style='font-size:14.0pt'><img width=555
					height=158 id="图片 8" src="../../../assets/images/case/image012.jpg"></span></p>

					<p class=MsoNormal><b><span style='font-size:14.0pt;font-family:宋体'>应用商店：</span></b><span
					style='font-size:14.0pt;font-family:宋体'>这里基本是额外的一些服务需求，由第三方的服务商与亚马逊平台提供的一些辅助性工具，是亚马逊推荐的一些移动软件，通常会用不上，如果有需要即可以下载使用。</span></p>

					<p class=MsoNormal><span lang=EN-US style='font-size:14.0pt'>&nbsp;</span></p>

					<p class=MsoNormal style='margin-left:0cm;text-indent:0cm'><span lang=EN-US
					style='font-size:14.0pt'>十二、</span><b><span style='font-size:16.0pt;font-family:
					宋体'>设置</span></b></p>

					<p class=MsoNormal><span lang=EN-US><img width=554 height=171 id="图片 9"
					src="../../../assets/images/case/image013.jpg"></span></p>

					<p class=MsoNormal style='margin-left:21.0pt;text-indent:-21.0pt'><span
					lang=EN-US style='font-size:8.0pt;font-family:Wingdings'>l<span
					style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp; </span></span><b><span
					style='font-size:14.0pt;font-family:宋体'>账户信息：</span></b><span style='font-size:
					14.0pt;font-family:宋体'>这里可以修改设置账户的所有信息，包括你的店铺名称、付款信息、业务、发退货，税务信息都可以从这里进行修改。</span></p>

					<p class=MsoNormal style='margin-left:21.0pt;text-indent:-21.0pt'><span
					lang=EN-US style='font-size:8.0pt;font-family:Wingdings'>l<span
					style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp; </span></span><b><span
					style='font-size:14.0pt;font-family:宋体'>全球账户：</span></b><span style='font-size:
					14.0pt;font-family:宋体'>我们全部商城都会在这里显示，并且可以看到商城的前端链接地址。</span></p>

					<p class=MsoNormal style='margin-left:21.0pt;text-indent:-21.0pt'><span
					lang=EN-US style='font-size:8.0pt;font-family:Wingdings'>l<span
					style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp; </span></span><b><span
					style='font-size:14.0pt;font-family:宋体'>通知首选项：</span></b><span
					style='font-size:14.0pt;font-family:宋体'>设置你想要收到的通知，包括订单出售通知，退款跟索赔通知，商品库存发生变动都可以及时通知到你。</span></p>

					<p class=MsoNormal><span lang=EN-US style='font-size:14.0pt'>&nbsp;</span></p>
					<p class=MsoNormal style='margin-left:21.0pt;text-indent:-21.0pt'><span
					lang=EN-US style='font-size:8.0pt;font-family:Wingdings'>l<span
					style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp; </span></span><b><span
					style='font-size:14.0pt;font-family:宋体'>登录设置：</span></b><span
					style='font-size:14.0pt;font-family:宋体'>编辑登录设置</span><span
					style='font-size:14.0pt;font-family:宋体'>登录与安全方面的设置，如修改登录密码、账号邮箱、两步验证等信息</span></p>
					<!-- <p style='margin-top:0cm;margin-right:0cm;margin-bottom:5.0pt;margin-left:
					21.0pt;text-indent:-21.0pt;background:white'><span lang=EN-US style='font-size:
					8.0pt;font-family:Wingdings;font-weight:normal'>l<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;
					</span></span><span style='font-size:14.0pt;color:black'>登录设置：</span><span
					style='font-size:14.0pt;color:black;font-weight:normal'>编辑登录设置</span><span
					lang=EN-US style='font-size:14.0pt;font-family:"Calibri",sans-serif;color:black;
					font-weight:normal'>(</span><span style='font-size:14.0pt;color:black;
					font-weight:normal'>登录与安全方面的设置，如修改登录密码、账号邮箱、两步验证等信息</span><span lang=EN-US
					style='font-size:14.0pt;font-family:"Calibri",sans-serif;color:black;
					font-weight:normal'>)</span></p> -->

					<p class=MsoNormal style='margin-left:21.0pt;text-indent:-21.0pt'><span
					lang=EN-US style='font-size:8.0pt;font-family:Wingdings'>l<span
					style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp; </span></span><b><span
					style='font-size:14.0pt;font-family:宋体'>退货设置：</span></b><span style='font-size:
					14.0pt;font-family:宋体'>可以添加不退货退款政策，还有买家退货时的一个默认地址</span></p>

					<p class=MsoNormal style='margin-left:21.0pt;text-indent:-21.0pt'><span
					lang=EN-US style='font-size:8.0pt;font-family:Wingdings'>l<span
					style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp; </span></span><b><span
					style='font-size:14.0pt;font-family:宋体'>礼品选项：</span></b><span style='font-size:
					14.0pt;font-family:宋体'>赠送的礼物外包装，礼物的留言信息，可以通过这里填写。</span></p>

					<p class=MsoNormal style='margin-left:21.0pt;text-indent:-21.0pt'><span
					lang=EN-US style='font-size:8.0pt;font-family:Wingdings'>l<span
					style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp; </span></span><b><span
					style='font-size:14.0pt;font-family:宋体'>配送设置：</span></b><span style='font-size:
					14.0pt;font-family:宋体'>针对自发货物流的配送模板设置，可以在这里设置配送服务级别。是标准配送还是加急配送，或者是隔日达。</span></p>

					<p class=MsoNormal style='margin-left:21.0pt;text-indent:-21.0pt'><span
					lang=EN-US style='font-size:8.0pt;font-family:Wingdings'>l<span
					style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp; </span></span><b><span
					style='font-size:14.0pt;font-family:宋体'>税务设置：</span></b><span style='font-size:
					14.0pt;font-family:宋体'>亚马逊的税务计算服务提供了一种方法来帮助确定和应用订单的销售税和使用税，但卖家仍需自行审核并确定正确的</span><span
					lang=EN-US style='font-size:14.0pt'> PTC</span><span style='font-size:14.0pt;
					font-family:宋体'>、计算设置以及其商品的所有相关信息，并需要向相应的税务机构证明和支付其交易应缴纳的所有税费。</span></p>

					<p class=MsoNormal style='margin-left:21.0pt;text-indent:-21.0pt'><span
					lang=EN-US style='font-size:8.0pt;font-family:Wingdings'>l<span
					style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp; </span></span><b><span
					style='font-size:14.0pt;font-family:宋体'>用户权限：</span></b><span style='font-size:
					14.0pt;font-family:宋体'>通过这里可以设置你的子账号给到工作人员，在子账号上设置他可以使用卖家后台的一些权限功能。</span></p>

					<p class=MsoNormal style='margin-left:21.0pt;text-indent:-21.0pt'><span
					lang=EN-US style='font-size:8.0pt;font-family:Wingdings'>l<span
					style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp; </span></span><b><span
					style='font-size:14.0pt;font-family:宋体'>用户权限历史记录：</span></b><span
					style='font-size:14.0pt;font-family:宋体'>可以查看修改用户权限时的记录。</span></p>

					<p class=MsoNormal style='margin-left:21.0pt;text-indent:-21.0pt'><span
					lang=EN-US style='font-size:8.0pt;font-family:Wingdings'>l<span
					style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp; </span></span><b><span
					style='font-size:14.0pt;font-family:宋体'>您的信息和政策：</span></b><span
					style='font-size:14.0pt;font-family:宋体'>是可以创建要提供给买家的相关业务信息的地方。</span></p>

					<p class=MsoNormal style='margin-left:21.0pt;text-indent:-21.0pt'><span
					lang=EN-US style='font-size:8.0pt;font-family:Wingdings'>l<span
					style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp; </span></span><b><span
					style='font-size:14.0pt;font-family:宋体'>亚马逊物流：</span></b><span
					style='font-size:14.0pt;font-family:宋体'>主要是关于亚马逊物流服务的一些可选服务设置，商品翻新设置服务开启，不可售商品自动移除设置，都可以从这里找到。</span></p>

					<p class=MsoNormal><span lang=EN-US style='font-size:18.0pt'>&nbsp;</span></p>

					<p class=MsoNormal><span style='font-size:14.0pt;font-family:宋体'>好了，我们这次的案例到这里就基本完结了，如果想实际操作可以在我们的模拟页面去进行操作熟悉一下页面。感谢使用零距离模拟网站。</span><span
					lang=EN-US style='font-size:14.0pt'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
					</span></p>

					<p class=MsoNormal style='text-indent:168.0pt'><span style='font-size:12.0pt;
					font-family:宋体;color:#C00000'>本案例知识点均为原创，如需转载请标明出处。</span><span
					style='font-size:14.0pt'> </span></p>

					<p class=MsoNormal><span lang=EN-US style='font-size:18.0pt'>&nbsp;</span></p>

					</div>
			</div>
		</div>
		<Downloads :isLond="isLond" :londFun="londFun"></Downloads>
  </div>
</template>
<script>
import Downloads from '../../../components/Downloads/Index'
export default {
  name: "courseDetail",
  components: {
	  Downloads
  },
  data: function() {
    return {
		 isLond:false,
    }
  },
  created(){
  },
  mounted () {
  },
  computed: {
    user() {
      return this.$store.getters.user;
	},
  },
  methods: {
	   londFun(e){
       this.isLond= e
     },
  }
  
};
</script>
<style lang="scss" scoped>
.boxWraps{
	width: 960px;
	margin: 40px auto 40px;
	img{
		display: block;
		margin: 20px auto;
	}
	p{
		line-height: 20px;
	}
	span{
		line-height: 38px;
	}
}
.avts{
	color: #4A9F64 !important;;
}
.caseDetail{
	.content{
		margin: 0 auto;
		width: 1200px;
		.banner{
			display: flex;
			.left{
				width: 378px;
				height: 217px;
				background: #ECECEC;
				img{
					width: 100%;
					height: 100%;
				}
			}
			.right{
				width: 780px;
				margin-left: 30px;
				position: relative;
				.btnWrap{
					position: absolute;
					right: 0;
					top: 0;
					.btn{
						width: 120px;
						height: 30px;
						background: #FBCA61;
						border-radius: 15px;
						line-height: 30px;
						font-size: 12px;
						color: #333333;
						cursor: pointer;
						text-align: center;
					}
				}
				.name{
					height: 21px;
					font-size: 20px;
					font-family: Microsoft YaHei;
					font-weight: bold;
					color: #333333;
					line-height: 21px;
					width: 362px;
					span{
						color: #BD8D63;
						margin-left: 9px;
						vertical-align: middle;
						line-height: 21px;
					}
				}
				.dev{
					height: 13px;
					font-size: 12px;
					font-family: Microsoft YaHei;
					font-weight: 400;
					line-height: 13px;
					color: #333333;
					margin-top:10px;
					width: 362px;
				}
				.sm{
					margin-top: 13px;
					height: 32px;
					font-size: 12px;
					font-family: Microsoft YaHei;
					font-weight: 400;
					color: #999;
					line-height: 16px;
					width: 418px;
				}
				.product{
					margin-top: 21px;
					.title{
						height: 10px;
						font-size: 10px;
						font-family: Microsoft YaHei;
						font-weight: 400;
						color: #666666;
						line-height: 10px;
					}
					.ul{
						margin-top: 19px;
						display: flex;
						.li{
							// padding-right: 12px;
							margin-left: 24px;
							width: 132px;
							text-align: center;
							position: relative;
							.img{
								height: 18px;
								text-align: center;
								margin-bottom: 9px;
							}
							.na{
								height: 14px;
								font-size: 14px;
								font-family: Microsoft YaHei;
								font-weight: bold;
								color: #333333;
								line-height: 14px;
								margin-bottom: 5px;
							}
							.dl{
								    height: 34px;
									font-size: 12px;
									font-family: Microsoft YaHei;
									font-weight: 400;
									color: #999;
									line-height: 17px;
							}
						}
						.li::after{
							content: "";
							height: 100%;
							width: 1px;
							position: absolute;
							right:-12px;
							top: 0;
							background: #EEEEEE;
						}
						.li:first-of-type{
							margin-left: 0;
						}
						.li:last-of-type::after{
							display: none;
						}
					}
				}
			}
		}
	}
}
.head{
	width: 1200px;
	height: 49px;
	line-height: 49px;
	box-sizing:border-box;
	margin: 15px auto 0;

}
.head .tit{
	height: 17px;
	line-height: 17px;
	font-size: 12px;
	color: #333333;
	i{
		cursor: pointer;
		font-style:normal;
	}
	span{
		font-size: 12px;
		color: #178aff;
		margin-left: 10px;
	}
}
</style>
<style >
</style>
